module.exports = __webpack_public_path__ + "static/media/backoffice-templates.de0ca3be.png";